module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSectionVisible) ? _c('div', {
    staticClass: "share-here"
  }, [(_vm.isStorySubmitted) ? [_vm._m(0)] : [(_vm.hr == 'above') ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Every inscription has a story. Share yours here!")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('form', {
    staticClass: "info-form",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      'has-error': _vm.errors.has('story.first_name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.story.first_name),
      expression: "story.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name",
      "data-vv-name": "story.first_name"
    },
    domProps: {
      "value": (_vm.story.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.story.first_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      'has-error': _vm.errors.has('story.last_name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.story.last_name),
      expression: "story.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name",
      "data-vv-name": "story.last_name"
    },
    domProps: {
      "value": (_vm.story.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.story.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      'has-error': _vm.errors.has('story.phone')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.story.phone),
      expression: "story.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10'),
      expression: "'required|digits:10'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "Phone Number",
      "data-vv-name": "story.phone"
    },
    domProps: {
      "value": (_vm.story.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.story.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      'has-error': _vm.errors.has('story.email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.story.email),
      expression: "story.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "data-vv-name": "story.email"
    },
    domProps: {
      "value": (_vm.story.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.story.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order),
      expression: "order"
    }],
    attrs: {
      "type": "hidden",
      "name": "order_id"
    },
    domProps: {
      "value": (_vm.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('form', {
    staticClass: "info-form",
    attrs: {
      "action": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.story.description),
      expression: "story.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter your story here. Share with us the meaning behind your inscription or what Cal State Fullerton means to you. Your stories and photos can become a part of history that will never be forgotten!"
    },
    domProps: {
      "value": (_vm.story.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.story.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('em', {
    staticClass: "text-small"
  }, [_vm._v("\n                    By submitting your story and related photos, you grant California State University, Fullerton, its affiliates and partners irrevocable permission to use your story and/or to create derivative works and/or adaptations of your story for marketing purposes, including, but not limited to social media, television, radio, and print marketing. Further, your submission of this form indicates your authorization for California State University, Fullerton to contact you for additional information.\n                ")])])]), _vm._v(" "), (_vm.isUploadFailed) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "text-danger"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', {
    staticClass: "btn btn-outline-danger pointer",
    attrs: {
      "for": "file-upload"
    }
  }, [_vm._v("Upload Photo")]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.file.isUploaded) ? _c('span', [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" " + _vm._s(_vm.file.name) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.onHide
    }
  }, [_vm._v("No Thanks")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Submit Story")])])])])]), _vm._v(" "), (_vm.hr == 'below') ? _c('hr') : _vm._e()]], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('div', {
    staticClass: "text-danger"
  }, [_c('h4', [_c('strong', [_vm._v("Thank you for sharing your story!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48e69376","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareStory.vue
// module id = r8DM
// module chunks = 1